/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundDocumentActivityEntry } from './InboundDocumentActivityEntry';
import {
    InboundDocumentActivityEntryFromJSON,
    InboundDocumentActivityEntryFromJSONTyped,
    InboundDocumentActivityEntryToJSON,
    InboundDocumentActivityEntryToJSONTyped,
} from './InboundDocumentActivityEntry';

/**
 * 
 * @export
 * @interface InboundDocumentActivityPage
 */
export interface InboundDocumentActivityPage {
    /**
     * 
     */
    data: Array<InboundDocumentActivityEntry>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the InboundDocumentActivityPage interface.
 */
export function instanceOfInboundDocumentActivityPage(value: object): value is InboundDocumentActivityPage {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function InboundDocumentActivityPageFromJSON(json: any): InboundDocumentActivityPage {
    return InboundDocumentActivityPageFromJSONTyped(json, false);
}

export function InboundDocumentActivityPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundDocumentActivityPage {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(InboundDocumentActivityEntryFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function InboundDocumentActivityPageToJSON(json: any): InboundDocumentActivityPage {
    return InboundDocumentActivityPageToJSONTyped(json, false);
}

export function InboundDocumentActivityPageToJSONTyped(value?: InboundDocumentActivityPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(InboundDocumentActivityEntryToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

